// extracted by mini-css-extract-plugin
export default {"tooltip":"iq-z","sharingV2":"jq-z","sharingIconsV2":"kq-z","links":"lq-z","link":"mq-z","facebookV2":"nq-z","twitterV2":"oq-z","pinterestV2":"pq-z"};